import React from 'react';
import { cn } from '../../utils/cn';

export function Topbar({ className, children, ...rest }) {
  return (
    <header
      className={cn(
        'h-topbar flex items-center px-6 gap-4 border-b border-border bg-bg/80 backdrop-blur sticky top-0 z-raised',
        className,
      )}
      {...rest}
    >
      {children}
    </header>
  );
}

function Left({ className, children }) {
  return <div className={cn('flex items-center gap-3', className)}>{children}</div>;
}
function Center({ className, children }) {
  return <div className={cn('flex-1 max-w-lg mx-auto', className)}>{children}</div>;
}
function Right({ className, children }) {
  return <div className={cn('flex items-center gap-2', className)}>{children}</div>;
}

Topbar.Left = Left;
Topbar.Center = Center;
Topbar.Right = Right;

export default Topbar;
